import { Locales } from '../../models/locale/locales';

/** Every locale the app ships translations for. Rosières is French-only. */
export const LOCALES: Locales[] = ['fr-FR'];

export const isValidLocale = (locale: string | null | undefined): locale is Locales =>
  !!locale && LOCALES.includes(locale as Locales);

/**
 * The locale the visitor asked for via `?lang=`, or undefined when the param is
 * missing or names a locale we do not ship.
 *
 * Deliberately does NOT fall back to a default: analytics should record that a
 * visitor arrived without a usable `?lang=` rather than silently attribute them
 * to France. The UI has its own fallback (see context/locale/provider.tsx).
 */
export const getUrlLocale = (search: string = window.location.search): Locales | undefined => {
  const locale = new URLSearchParams(search).get('lang');
  return isValidLocale(locale) ? locale : undefined;
};

/**
 * ISO 3166-1 alpha-2 country for a locale, for dashboards that group by country
 * rather than by locale string. Rosières ships only `fr-FR` (France).
 */
const LOCALE_COUNTRY: Record<Locales, string> = {
  'fr-FR': 'FR',
};

export const getCountry = (locale: Locales | undefined): string | undefined =>
  locale ? LOCALE_COUNTRY[locale] : undefined;
